import styled from "styled-components";
import { Button, Row } from "antd";

export const Wrapper = styled.div`
  padding: 20px;
  width: 1050px;
  background: ${({ theme }) => theme.colorNeutral100};
  height: 600px;
`;
export const Content = styled.div`
  width: 1024px;
  height: 70%;
  overflow: auto;
`;
export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  margin-right: 20px;
`;
export const CustomButton = styled(Button)<{ marginRight?: string; width?: string }>`
  margin-right: ${({ marginRight }) => marginRight || ""};
  width: ${({ width }) => width || ""};
`;
export const CustomRow = styled(Row)`
  margin-top: 13px;
`;

export const Notes = styled.div<{ isExpanded?: boolean }>`
  text-align: left;
  margin: 15px 0;
  white-space: normal;
  overflow-y: ${({ isExpanded }) => (isExpanded ? "hidden" : "scroll")};
  max-height: 112px;
`;
export const ExpandIconImg = styled.img`
  background-color: #fff;
  position: absolute;
  right: 10px;
  bottom: 10px;
  cursor: pointer;
`;
export const NotesWrapper = styled.div`
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
`;
export const NameWrapper = styled.div``;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  padding: 0 25px;
`;
